export default "/images/candy-image-100.png?dec8758ebcb30455d394050a66f759df";